// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalWrapper--aRycc {
  position: fixed;
  background-color: #FFF;
  width: 100vw;
  height: 100vh;
  z-index: 51;
  top: 0;
}
.modalWrapper--aRycc .modal--O4b50 {
  background-color: #FFF;
  border-radius: 4px;
}
.modalWrapper--aRycc .modal--O4b50::-webkit-scrollbar {
  width: 7px;
}
.modalWrapper--aRycc .modal--O4b50::-webkit-scrollbar-track {
  border-radius: 100vh;
  background: none;
}
.modalWrapper--aRycc .modal--O4b50::-webkit-scrollbar-thumb {
  background: #BCCDFF;
  border-radius: 100vh;
}
.modalWrapper--aRycc .modalContent--d28qf {
  padding: 1rem;
  margin-bottom: 5rem;
}
.modalWrapper--aRycc .modalHeader--xDk0z {
  display: flex;
  justify-items: start;
  align-items: center;
  margin-bottom: 1.75rem;
  height: 2rem;
}
.modalWrapper--aRycc .modalHeader--xDk0z svg {
  width: 1.5rem;
  height: 1.5rem;
}
.modalWrapper--aRycc .modalFooter--PPFRo {
  display: flex;
  align-items: flex-end;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.13);
  background: white;
  z-index: 2;
  width: 100%;
}
.modalWrapper--aRycc .oneButtonFooter--CDKCd {
  justify-content: flex-end;
}
.modalWrapper--aRycc .twoButtonFooter--AKiDa {
  justify-content: space-between;
}
@media screen and (min-width: 768px) {
  .modalWrapper--aRycc {
    height: 100%;
    display: flex;
    background: rgba(0, 0, 0, 0.5);
  }
  .modalWrapper--aRycc .modal--O4b50 {
    @apply p-8 bg-white rounded m-auto;
    position: relative;
    width: 764px;
    max-width: 85vw;
    box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.13);
    margin: 2rem auto;
    height: -moz-fit-content;
    height: fit-content;
  }
  .modalWrapper--aRycc .modal--O4b50.small--lkTY2 {
    width: 596px;
  }
  .modalWrapper--aRycc .modalContent--d28qf {
    @apply p-0;
    height: -moz-fit-content;
    height: fit-content;
    margin-bottom: 0;
  }
  .modalWrapper--aRycc .modalHeader--xDk0z {
    @apply flex flex-row justify-between w-full mb-3 bg-white;
  }
  .modalWrapper--aRycc .modalFooter--PPFRo {
    @apply flex relative mt-8 p-0 w-auto h-11 rounded-none;
    box-shadow: none;
  }
  .modalWrapper--aRycc .oneButtonFooter--CDKCd {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/bodal/style.module.less"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,MAAA;AAFF;AAJA;EASI,sBAAA;EACA,kBAAA;AAFJ;AAII;EACE,UAAA;AAFN;AAKI;EACE,oBAAA;EACA,gBAAA;AAHN;AAMI;EACE,mBAAA;EACA,oBAAA;AAJN;AAnBA;EA4BI,aAAA;EACA,mBAAA;AANJ;AAvBA;EAiCI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AAPJ;AA9BA;EAwCM,aAAA;EACA,cAAA;AAPN;AAlCA;EA8CI,aAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gDAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AATJ;AA5CA;EAyDI,yBAAA;AAVJ;AA/CA;EA6DI,8BAAA;AAXJ;AAeA;EACE;IACE,YAAA;IACA,aAAA;IACA,8BAAA;EAbF;EAUA;IAMI,kCAAA;IACA,kBAAA;IACA,YAAA;IACA,eAAA;IACA,+CAAA;IACA,iBAAA;IACA,wBAAA;IAAA,mBAAA;EAbJ;EACA;IAgBI,YAAA;EAdJ;EAFA;IAoBI,UAAA;IACA,wBAAA;IAAA,mBAAA;IACA,gBAAA;EAfJ;EAPA;IA0BI,yDAAA;EAhBJ;EAVA;IA8BI,sDAAA;IACA,gBAAA;EAjBJ;EAdA;IAmCI,uBAAA;EAlBJ;AACF","sourcesContent":["@import \"@boclips-ui/styles/src/colors\";\n@import \"~@boclips-ui/styles/src/breakpoints\";\n\n.modalWrapper {\n  position: fixed;\n  background-color: @white;\n  width: 100vw;\n  height: 100vh;\n  z-index: 51; // header is set to 50\n  top: 0;\n\n  .modal {\n    background-color: @white;\n    border-radius: 4px;\n\n    &::-webkit-scrollbar {\n      width: 7px;\n    }\n\n    &::-webkit-scrollbar-track {\n      border-radius: 100vh;\n      background: none;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: @blue-500;\n      border-radius: 100vh;\n    }\n  }\n\n  .modalContent {\n    padding: 1rem;\n    margin-bottom: 5rem;\n  }\n\n  .modalHeader {\n    display: flex;\n    justify-items: start;\n    align-items: center;\n    margin-bottom: 1.75rem;\n    height: 2rem;\n\n    svg {\n      width: 1.5rem;\n      height: 1.5rem;\n    }\n  }\n\n  .modalFooter {\n    display: flex;\n    align-items: flex-end;\n    padding: 0.5rem 1rem;\n    border-radius: 0.25rem;\n    box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.13);\n    background: white;\n    z-index: 2;\n    width: 100%;\n  }\n\n  .oneButtonFooter {\n    justify-content: flex-end;\n  }\n\n  .twoButtonFooter {\n    justify-content: space-between;\n  }\n}\n\n@media screen and (min-width: @screen-md) {\n  .modalWrapper {\n    height: 100%;\n    display: flex;\n    background: rgba(black, 0.5);\n\n    .modal {\n      @apply p-8 bg-white rounded m-auto;\n      position: relative;\n      width: 764px;\n      max-width: 85vw;\n      box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.13);\n      margin: 2rem auto;\n      height: fit-content;\n    }\n\n    .modal.small {\n      width: 596px;\n    }\n\n    .modalContent {\n      @apply p-0;\n      height: fit-content;\n      margin-bottom: 0;\n    }\n\n    .modalHeader {\n      @apply flex flex-row justify-between w-full mb-3 bg-white;\n    }\n\n    .modalFooter {\n      @apply flex relative mt-8 p-0 w-auto h-11 rounded-none;\n      box-shadow: none;\n    }\n\n    .oneButtonFooter {\n      justify-content: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `modalWrapper--aRycc`,
	"modal": `modal--O4b50`,
	"modalContent": `modalContent--d28qf`,
	"modalHeader": `modalHeader--xDk0z`,
	"modalFooter": `modalFooter--PPFRo`,
	"oneButtonFooter": `oneButtonFooter--CDKCd`,
	"twoButtonFooter": `twoButtonFooter--AKiDa`,
	"small": `small--lkTY2`
};
export default ___CSS_LOADER_EXPORT___;
